const PROJECT_ID_IN_PATH = /^\/projects\/(\d+)/

export function extractProjectIdFromPathname(pathname: string): number | undefined {
  const match = pathname.match(PROJECT_ID_IN_PATH)
  if (!match) {
    return undefined
  }
  const id = parseInt(match[1], 10)
  return isNaN(id) ? undefined : id
}

function asNumericProjectId(value: unknown): number | undefined {
  if (typeof value === 'number' && value > 0) {
    return value
  }
  if (typeof value === 'string' && value !== 'new' && value !== 'replay') {
    const id = parseInt(value, 10)
    if (id > 0) {
      return id
    }
  }
  return undefined
}

/** Pathname is authoritative when the user is on a project page; redux is the fallback elsewhere. */
export function resolveCurrentProjectId(pathname: string, reduxProjectId?: unknown): number | undefined {
  return extractProjectIdFromPathname(pathname) ?? asNumericProjectId(reduxProjectId)
}
